import { BookingInlineActions, ManualEntryInlineActions } from '../../ScheduledBookings';
import { AbsenceInlineActions } from '../../Absences';
import type { TimesheetEntry } from '@/types/timesheet';

export interface RowActionsCellProps {
  entry: TimesheetEntry;
  index: number;
  isReadOnly: boolean;
  isScheduled: boolean;
  isAbsence: boolean;
  canDuplicate: boolean;
  canDelete: boolean;
  /** Whether the overtime classification action is available for manual entries. */
  canClassifyOvertime: boolean;
  onDuplicate: (index: number) => void;
  onDelete: (index: number) => void;
  onViewBookingDetails: (entry: TimesheetEntry) => void;
  onViewAbsenceDetails: (entry: TimesheetEntry) => void;
  onClassifyOvertime: (entry: TimesheetEntry) => void;
}

/** Inline actions cell, switching on the row's entry type. */
export function RowActionsCell({
  entry,
  index,
  isReadOnly,
  isScheduled,
  isAbsence,
  canDuplicate,
  canDelete,
  canClassifyOvertime,
  onDuplicate,
  onDelete,
  onViewBookingDetails,
  onViewAbsenceDetails,
  onClassifyOvertime,
}: RowActionsCellProps) {
  return (
    <td className="p-1 sm:p-1.5">
      <div className="flex items-center justify-center gap-0.5 sm:gap-1">
        {/* No actions for absence entries */}
        {isAbsence ? (
          <AbsenceInlineActions onViewDetails={() => onViewAbsenceDetails(entry)} />
        ) : (
          <>
            {/* Scheduled Booking Inline Actions */}
            {isScheduled && (
              <BookingInlineActions
                booking={entry}
                onDuplicate={canDuplicate ? () => onDuplicate(index) : undefined}
                onDelete={canDelete ? () => onDelete(index) : undefined}
                onViewDetails={() => onViewBookingDetails(entry)}
                disabled={isReadOnly}
                readOnlyMode={isReadOnly}
              />
            )}

            {/* Manual Entry Inline Actions — always render for manual entries so the menu icon is consistent */}
            {!isScheduled && (
              <ManualEntryInlineActions
                onDuplicate={!isReadOnly && canDuplicate ? () => onDuplicate(index) : undefined}
                onDelete={!isReadOnly && canDelete ? () => onDelete(index) : undefined}
                disabled={isReadOnly}
                onClassifyOvertime={
                  !isReadOnly && canClassifyOvertime ? () => onClassifyOvertime(entry) : undefined
                }
              />
            )}
          </>
        )}
      </div>
    </td>
  );
}
